export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";